import React from 'react';
import Box from '../Box';
const InputWrapper = _ref => {
  let {
    children,
    dataCy,
    disabled,
    errorSx,
    validationIcon,
    htmlFor,
    input,
    inputWrapperSx,
    label,
    labelSx,
    meta,
    subtext,
    wrapperSx,
    ...rest
  } = _ref;
  const error = meta.error && meta.touched;
  let below = null;
  if (error) {
    below = /*#__PURE__*/React.createElement(Box, {
      sx: {
        color: 'error',
        fontSize: 2,
        mt: 1,
        ...errorSx
      }
    }, meta.error);
  } else if (subtext) {
    below = /*#__PURE__*/React.createElement(Box, {
      fontSize: 2,
      mt: 1
    }, subtext);
  }
  return /*#__PURE__*/React.createElement(Box, {
    "data-cy": dataCy,
    sx: {
      '&:first-of-type': {
        mt: 0
      },
      flex: 1,
      mt: 6,
      opacity: disabled ? '0.3' : null,
      pointerEvents: disabled ? 'none' : null,
      position: 'relative',
      ...wrapperSx
    }
  }, label && /*#__PURE__*/React.createElement(Box, {
    as: "label",
    htmlFor: htmlFor || input.name,
    sx: {
      color: 'text.subtle',
      cursor: 'pointer',
      display: 'block',
      fontSize: 2,
      fontWeight: 'bold',
      letterSpacing: 0,
      mb: 1,
      textTransform: 'uppercase',
      ...labelSx
    }
  }, label), /*#__PURE__*/React.createElement(Box, {
    sx: {
      position: 'relative',
      ...inputWrapperSx
    }
  }, children({
    disabled,
    error,
    ...rest
  }), validationIcon && meta.touched && /*#__PURE__*/React.createElement(Box, {
    sx: {
      alignItems: 'center',
      bg: 'white',
      color: "" + (error ? 'error' : 'success'),
      display: 'flex',
      height: 'calc(100% - 4px)',
      m: '2px',
      position: 'absolute',
      right: '0',
      top: '0'
    }
  }, validationIcon(error))), below);
};
InputWrapper.defaultProps = {
  dataCy: null,
  disabled: false,
  errorSx: {},
  htmlFor: null,
  inputWrapperSx: {},
  label: null,
  labelSx: {},
  subtext: null,
  validationIcon: () => null,
  wrapperSx: {}
};
export default InputWrapper;